import { IEcommerceOrder } from 'shared/interfaces/ecommerce-order.interface';
import { http } from '../utils/axios';

class EcommerceOrderService {
  private static instance: EcommerceOrderService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): EcommerceOrderService {
    if (!EcommerceOrderService.instance) {
      EcommerceOrderService.instance = new EcommerceOrderService();
    }

    return EcommerceOrderService.instance;
  }

  public getEcommerceOrderInfo = async ({ limit = 20, page = 1 }) => {
    const data = await http<{
      result: IEcommerceOrder[];
      count: number;
    }>({
      url: '/ecommerceOrders',
      method: 'GET',
      params: {
        limit,
        page
      }
    });
    return data;
  };

  public getOneEcommerceOrder = async (id: string) => {
    const { data } = await http<IEcommerceOrder>({
      url: `/ecommerceOrders/${id}`,
      method: 'GET'
    });
    return data;
  };

  public updateEcommerceOrder = async (id: string, payload: any) => {
    const { data } = await http<IEcommerceOrder>({
      url: `/ecommerceOrders/${id}`,
      method: 'PUT',
      data: payload
    });

    return data;
  };

  public getEcommerceOrderVariationsInfo = async ({
    limit = 20,
    page = 1,
    isMapped = undefined
  }) => {
    const data = await http<{
      result: IEcommerceOrder[];
      count: number;
    }>({
      url: '/ecommerceOrderVariations/mapping',
      method: 'GET',
      params: {
        limit,
        page,
        isMapped
      }
    });
    return data;
  };

  public mapEcommerceOrderVariation = async (epvtId: string, payload: any) => {
    const { data } = await http<any>({
      url: `/ecommerceOrderVariations/${epvtId}/mapping`,
      method: 'POST',
      data: payload
    });

    return data;
  };

  public createEcommerceOrder = async (payload: any) => {
    const { data } = await http<IEcommerceOrder>({
      url: '/ecommerceOrders',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public cancelEcommerceOrder = async (id: string) => {
    const { data } = await http<IEcommerceOrder>({
      url: `/ecommerceOrders/${id}/cancel`,
      method: 'PATCH'
    });

    return data;
  };

  public refundEcommerceOrder = async (id: string, payload: any) => {
    const { data } = await http<IEcommerceOrder>({
      url: `/ecommerceOrders/${id}/refund`,
      method: 'POST',
      data: payload
    });

    return data;
  };

  public validateCoupon = async (payload: any) => {
    const { data } = await http<any>({
      url: '/ecommerceCoupons/validate',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public generateShareLink = async (id: string) => {
    const { data } = await http<{
      success: boolean;
      shareUrl: string;
      expiresAt: string;
    }>({
      url: `/ecommerceOrders/${id}/generateShareLink`,
      method: 'PATCH'
    });

    return data;
  };

  public getAvailablePaymentMethods = async (patientId: string) => {
    const { data } = await http<any>({
      url: '/ecommerceOrders/patient/paymentMethods',
      method: 'GET',
      params: {
        patientId: patientId
      }
    });

    return data;
  };

  public attachPaymentMethod = async (payload: {
    patientId: string;
    paymentMethodId: string;
  }) => {
    const { data } = await http<any>({
      url: '/ecommerceOrders/patient/paymentMethods',
      method: 'POST',
      data: payload
    });

    return data;
  };
}

const instance = EcommerceOrderService.getInstance();

export default instance;
